var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAfter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M7.667 21h11.666c.92 0 1.667-.897 1.667-2V5c0-1.103-.747-2-1.667-2H7.667C6.747 3 6 3.897 6 5v14c0 1.103.747 2 1.667 2M19.333 5l.001 9H7.667V5zM1 21v-8l4 4z"
})));
export default SvgAfter;